import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptAppBrand } from "../../adapters/adaptAppBrands";

const fetchAppBrandById = async (id: number) => {
	const url = `/homepage/admin/app-branding/${id}/`;
	const response = await cmsClient.get<IAppBrand>(url);

	return response.data;
};

interface Options {
	onSuccess?: (data: Partial<AppBrand>) => void;
	enabled?: boolean;
}

const useAppBrand = (id: number, options: Options = {}) => {
	const query = useQuery(["app-brand", id], () => fetchAppBrandById(id), {
		select: adaptAppBrand,
		...options,
	});

	return query;
};

export default useAppBrand;
